var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAuth = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.9385 5C20.5953 5 21.9385 6.34315 21.9385 8V20C21.9385 21.6569 20.5953 23 18.9385 23H16.9385H14.9385H13.9385C13.3862 23 12.9385 22.5523 12.9385 22C12.9385 21.4477 13.3862 21 13.9385 21H14.9385H16.9385H18.9385C19.4908 21 19.9385 20.5523 19.9385 20V8C19.9385 7.44772 19.4908 7 18.9385 7H16.9385H14.9385H13.9385C13.3862 7 12.9385 6.55228 12.9385 6C12.9385 5.44772 13.3862 5 13.9385 5H14.9385H16.9385H18.9385Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3738 18.4571L15.1238 14.7071C15.5143 14.3166 15.5143 13.6834 15.1238 13.2929L11.3738 9.54289C10.9833 9.15237 10.3501 9.15237 9.95956 9.54289C9.56904 9.93342 9.56904 10.5666 9.95956 10.9571L12.0025 13L4 13C3.44771 13 3 13.4477 3 14C3 14.5523 3.44771 15 4 15H12.0025L9.95956 17.0429C9.56904 17.4334 9.56904 18.0666 9.95956 18.4571C10.3501 18.8476 10.9833 18.8476 11.3738 18.4571Z",
  fill: "currentColor"
})));
export { SvgAuth as ReactComponent };